// extracted by mini-css-extract-plugin
export default {"toggleArea":"ToggleButton_toggleArea__GOh0T","button":"ToggleButton_button__a55Qg","active":"ToggleButton_active__3jQZa"};